import { render, staticRenderFns } from "./RegistrationPersonalPayComplete.vue?vue&type=template&id=17b090d7&"
import script from "./RegistrationPersonalPayComplete.vue?vue&type=script&lang=js&"
export * from "./RegistrationPersonalPayComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports